import { caption, captionStrong } from '../../../common/styles/commonStyles';
import { IOrderViewerMainStore } from '../typing/stores';
import { OrderViewerColors } from '../utils/constants';
import { createStyles, makeStyles } from '@mui/styles';
import { Icons } from 'copyright-clearance-center-common-ui';
import { inject, observer } from 'mobx-react';

// use own constants here
// Colors.success500 and Colors.error500 have incorrect colors
const successColor = OrderViewerColors.success500;
const errorColor = OrderViewerColors.error500;

const useStyles = makeStyles(() =>
	createStyles({
		root: {
			display: 'flex',
			gap: '0.25rem',
			alignItems: 'center'
		},
		text: {
			...caption
		},
		strontText: {
			...captionStrong
		},
		statusRow: {
			display: 'flex',
			justifyContent: 'flex-end',
			alignItems: 'center',
			gap: '0.25rem'
		},
		requestRow: {
			display: 'flex',
			alignItems: 'flex-start',
			gap: '0.25rem'
		}
	})
);

export interface IRequestInfoProps {
	requestNumber?: string;
	isExpired?: boolean;
}

const RequestInfo: React.FunctionComponent<IRequestInfoProps> = props => {
	const classes = useStyles();

	const getStyles = () => {
		if (props.isExpired) {
			return {
				icon: Icons.DangerIcon,
				text: localize('Order expired'),
				color: errorColor
			};
		} else {
			return {
				icon: Icons.ApplyIcon,
				text: localize('Order complete'),
				color: successColor
			};
		}
	};

	const styles = getStyles();

	return (
		<div className={classes.root}>
			<div className={classes.statusRow} style={{ color: styles.color }} data-test-id="document-order-status">
				<span className="rup-icon rup-icon--sm" dangerouslySetInnerHTML={{ __html: styles.icon }} />
				<div className={classes.strontText} style={{ color: styles.color }}>
					{styles.text}
				</div>
			</div>
			<div className={classes.requestRow}>
				<div className={classes.strontText}>{`${localize('Request number')}:`}</div>
				<div className={classes.text} data-test-id="document-order-number">
					{props.requestNumber}
				</div>
			</div>
		</div>
	);
};

export default inject((stores: IOrderViewerMainStore) => ({
	requestNumber: stores.orderViewerStore.viewModel.headerModel.requestNumber,
	isExpired: stores.orderViewerStore.viewModel.isExpired
}))(observer(RequestInfo));
